import { Spinner } from '@common/components/Spinner';
import { useTranslations } from '@lang';
import { FC, ReactNode, useLayoutEffect, useRef } from 'react';
import { SavingAnnouncement, SavingContent } from './SavingRegion.styles';

type SavingRegionProps = {
  isSaving: boolean;
  children: ReactNode;
};

export const SavingRegion: FC<SavingRegionProps> = ({ isSaving, children }) => {
  const { t } = useTranslations();
  const contentRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    contentRef.current?.toggleAttribute('inert', isSaving);
  }, [isSaving]);

  return (
    <>
      <Spinner showDelayMessage isActive={isSaving} />
      <SavingAnnouncement role="status">
        {isSaving ? t('app.spinner.oneMomentPlease') : ''}
      </SavingAnnouncement>
      <SavingContent ref={contentRef} aria-busy={isSaving}>
        {children}
      </SavingContent>
    </>
  );
};
